export const selectDashboardList = (state) => state.dashboardlist;
